import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import Button from "src/components/atoms/Button";
import TextField from "src/components/atoms/Form/TextField";
import AuthService from "src/services/AuthService";
import * as yup from "yup";

type FormData = {
  email: string;
};

const schema = yup.object().shape({
  email: yup
    .string()
    .email("Correo electrónico inválido")
    .required("Correo electrónico es requerido"),
});

const ForgotPassword: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const resolver = yupResolver(schema);
  const methods = useForm<FormData>({
    resolver,
  });

  const { register, handleSubmit } = methods;

  const onSubmit = handleSubmit(async (data: FormData) => {
    try {
      setIsLoading(true);
      const response = await AuthService.forgotPassword(data.email);
      toast.success("Se ha enviado un correo para restablecer la contraseña", {
        duration: 5000,
      });
    } catch (err) {
      toast.error("Error recuperando contraseña");
    } finally {
      setIsLoading(false);
    }
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit}>
        <div className="space-y-8">
          <TextField
            {...register("email")}
            name="email"
            id="email"
            label="Email"
            placeholder="codealo@example.com"
          />
          <Button
            onClick={onSubmit}
            variant={"solid"}
            color={"primary"}
            size={"lg"}
            type={"submit"}
            block={true}
            loading={isLoading}
          >
            Restablecer Contraseña
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default ForgotPassword;
